/**
 * URL utility functions for AgentWizard
 */

/**
 * Normalize a URL by ensuring it has a protocol
 * If no protocol is present, prepends 'https://'
 * @param {string} value - The URL to normalize
 * @return {string} The normalized URL with protocol
 */
export const normalizeUrl = (value: string): string => {
  if (!value) {
    return value;
  }
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};
